import React, { useRef, useState } from 'react';
import {
  Container,
  HeaderWrapper,
  MainWrapper,
} from 'lib/components/styles/layout';
import { Heading } from 'lib/components/styles/typography';
import { Tab, Tabs } from 'lib/components/tabs';
import { useTheme } from 'styled-components/macro';
import { Content } from '../../aiAssistants/components/styles';
import { Button } from 'react-covideo-common';
import { MdAdd } from 'react-icons/md';
import { Highlights } from '../highlights/Highlights';
import { Pronunciations } from '../pronunciations/Pronunciations';
import { useAIFeatureAvailability } from 'lib/hooks/features/ai/useAIFeatureAvailability';
import { useTranslation } from 'react-i18next';

interface HighlightsRef {
  openAddModal: () => void;
}
interface PronunciationsRef {
  openAddModal: () => void;
}

export const Main = () => {
  const { t } = useTranslation();
  const {
    isPronunciationConfigurationAvailable,
    isDealershipHighlightsConfigurationAvailable,
  } = useAIFeatureAvailability();
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);
  const highlightsRef = useRef<HighlightsRef>(null);
  const pronunciationsRef = useRef<PronunciationsRef>(null);

  const dealershipHighlightsTab = {
    title: t('Dealership Highlights'),
    inActiveTextColor: theme.colors.neutral[60],
    component: <Highlights ref={highlightsRef} />,
  };

  const pronunciationsTab = {
    title: t('Pronunciations'),
    inActiveTextColor: theme.colors.neutral[60],
    component: <Pronunciations ref={pronunciationsRef} />,
  };

  const tabs: Tab[] = [
    ...(isDealershipHighlightsConfigurationAvailable
      ? [dealershipHighlightsTab]
      : []),
    ...(isPronunciationConfigurationAvailable ? [pronunciationsTab] : []),
  ];

  return (
    <Container>
      <MainWrapper resetPadding={false}>
        <HeaderWrapper m='0 0 26px 16px'>
          <Heading>{t('Personalization')}</Heading>
          {activeTab === 0 && (
            <Button
              text={t('Add Highlight')}
              icon={<MdAdd color={theme.colors.white[100]} />}
              onClick={() => highlightsRef.current?.openAddModal()}
            />
          )}
          {activeTab === 1 && (
            <Button
              text={t('Add Pronunciation')}
              icon={<MdAdd color={theme.colors.white[100]} />}
              onClick={() => pronunciationsRef.current?.openAddModal()}
            />
          )}
        </HeaderWrapper>
        <Content>
          <Tabs
            tabs={tabs}
            defaultActiveTab={activeTab}
            onChange={setActiveTab}
            navbarPadding='16px 0px 0px 0px'
          />
        </Content>
      </MainWrapper>
    </Container>
  );
};
